import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBXRyAIyJ9CsP20l15RvgTUC4qC2KRsnyk",
  authDomain: "aurora-console-e6c4c.firebaseapp.com",
  projectId: "aurora-console-e6c4c",
  storageBucket: "aurora-console-e6c4c.firebasestorage.app",
  messagingSenderId: "1028707303114",
  appId: "1:1028707303114:web:62f1837ccbfeffb3fe3e33",
  measurementId: "G-RLVXH0CLH8",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Firestore
export const db = getFirestore(app);

// Functions - specify region to match deployed functions
export const functions = getFunctions(app, 'us-central1');

export default app;
